//排课管理相关 api
import request from '@/api/request'
import { CancelToken } from 'axios';


// 获取修改页面数据
export function schedulingSaveApi(data: any) {
    let url = '/api/manager/scheduling/save';
    return request({
        url: url,
        method: 'post',
        data
    })
}


// 获取修改页面数据
export function schedulingEditInitApi(id: string) {
    let url = '/api/manager/scheduling/edit/init';
    let data = {
        "id": id
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}

// 获取修改页面数据
export function schedulingEditTypeApi(id: string,type:any,scid:any) {
    let url = '/api/manager/scheduling/edit/type';
    let data = {
        "id": id,
        "type" : type,
        "scid" : scid
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}

// 获取修改页面数据
export function schedulingEditCourseApi(id: string,courses:any) {
    let url = '/api/manager/scheduling/edit/course';
    let data = {
        "sid": id,
        "courses" : courses
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}



//  修改日期与地点
export function schedulingEditDateAndlocationApi(id:any,date:any,timetype:any,addresses:any){
    let url = '/api/manager/scheduling/edit/locationanddate';

    let data = {
        id : id,
        date : date,
        timetype : timetype,
        addresses: addresses
    }

    return request({
        url: url,
        method: 'post',
        data
    })
}

export function schedulingEditScoreApi(
    id:any, credithour:any
){

    let data = {
        id : id,
        credithour : credithour
    }


    let url = '/api/manager/scheduling/edit/score';
    return request({
        url: url,
        method: 'post',
        data
    })
}



// 修改日期和地点
export function schedulingEditDateaddressApi(data:any) {
    let url = '/api/manager/coursescheduling/location/exchange';
    return request({
        url: url,
        method: 'post',
        data
    })
}

// 修改学时和排课时间
export function schedulingEditClasshoursApi(data:any) {
    let url = '/api/manager/coursescheduling/credithourExchange';
    return request({
        url: url,
        method: 'post',
        data
    })
}

// 修改学时和排课时间
export function schedulingEditShowLevelApi(id :any,showlevel:any,bindUsers:any,bindPartys:any,bindUnits:any
) {
    let url = '/api/manager/scheduling/edit/showlevel';

    let data = {
        id: id,
        showlevel: showlevel,
        bindUnits: bindUnits,
        bindPartys: bindPartys,
        bindUsers: bindUsers
    }

    return request({
        url: url,
        method: 'post',
        data
    })
}



export function getAvailAbleSchedulingApi() {
    let url = '/api/manager/scheduling/getavailableschduling';

    let data = {
        "status":0
    }

    return request({
        url: url,
        method: 'post',
        data   
    })
}

export function getshowlevelbySid(
    sid:any
) {
    let url = '/api/manager/scheduling/getshowlevelbysid';

    let data = {
        "sid" : sid
    }

    return request({
        url: url,
        method: 'post',
        data
    })
}


export function schedulingBasicApi(id:any) {

    let data = {
        "id":id
    }

    let url = '/api/manager/scheduling/detail/basic';
    return request({
        url: url,
        method: 'post',
        data
    })
}

export function optionsStatApi(word:any) {

    let data = {
        "word":word
    }

    let url = '/api/manager/scheduling/stat/options';
    return request({
        url: url,
        method: 'post',
        data
    })
}


export function getSchedulingAdddresss(){
    let addressAry = new Array();

    let addresses = [
        {
            "name": "（体育大厦主会场） 南京西路150号体育大厦",
            "lat": 31.233858,
            "lng": 121.471839,
            "level":0
        },
        {
            "name": "（武术院分会场） 杨浦区政立路120号",
            "lat": 31.307757,
            "lng": 121.51765,
            "level":0
        },
        {
            "name": "（场馆中心分会场） 徐汇区钦州路728号",
            "lat": 31.174614,
            "lng": 121.42863,
            "level":0
        },
        {
            "name": "（科体中心分会场） 广中路444号",
            "lat": 31.278806,
            "lng": 121.471605,
            "level":0
        },
        {
            "name" : "（射击射箭中心分会场） 上海市射击射箭运动中心",
            "lat": 31.084847,
            "lng": 121.397558,
            "level":0
        },
        {
            "name": "（马术中心分会场） 金山区金廊公路6300号",
            "lat": 30.879749,
            "lng": 121.182229,
            "level":0
        },
        // {
        //     "name": "（东体大厦分会场） 泳耀路300号东方体育大厦",
        //     "lat": 31.158187,
        //     "lng": 121.477384
        // },
        {
            "name": "（棋牌大厦分会场） 南京西路595号上海棋牌院",
            "lat": 31.230676,
            "lng": 121.465639,
            "level":0
        },
        {
            "name": "（二体校分会场） 莘东路589号上海市第二体育运动学校",
            "lat": 31.115356,
            "lng": 121.370958,
            "level":0
        },
        {
            "name":"（市体校分会场） 水电路176号上海市体育运动学校",
            "lat": 31.275976,
            "lng": 121.471708,
            "level":0
        },
        {
            "name":"（绿舟基地分会场） 东方绿舟体育训练基地",
            "lat": 31.109942,
            "lng": 121.011512,
            "level":2
        },
        {
            "name": "（崇明基地分会场） 上海崇明竞技体育训练管理中心",
            "lat": 31.533945,
            "lng": 121.855836,
            "level":0
        },
        // {
        //     "name": "（划船俱乐部） 龙吴路1594号上海市划船俱乐部",
        //     "lat": 31.13483,
        //     "lng": 121.455829
        // },
        {
            "name": "（体彩中心分会场） 长乐路1240号",
            "lat": 31.214961,
            "lng": 121.440644,
            "level":0
        },
        {
            "name": "（体科所分会场） 上海市徐汇区吴兴路87号",
            "lat":31.2063,
            "lng": 121.441978,
            "level":0
        },
        {
            "name": "(久事体育大厦分会场) 久事体育大厦",
            "lat": 31.17969,
            "lng": 121.440099,
            "level":0
        }
    ]


    for(let i = 0 ; i < addresses.length; i++){
        let level = addresses[i].level;
        if(!level){
            level = 0;
        }

        let address = {
            address : addresses[i].name,
            lat : addresses[i].lat, 
            lng : addresses[i].lng,
            gpsoffsetlevel : level
        }
        addressAry.push(address);
    }

    return addressAry;
}




// 获取修改页面数据
export function schedulingTodayApi() {
    let url = '/api/manager/scheduling/today';
    return request({
        url: url,
        method: 'get'
    })
}